import React, { useEffect, useRef, useState } from 'react';
import { Button, Layout, Modal, notification, Space, theme } from 'antd';
import type { GetRef, TourProps } from 'antd';

import style from './HomePage.module.css';

import { Header } from 'antd/es/layout/layout';
import { useTranslation } from 'react-i18next';
import HomeHeaderBar from '../../Components/HomeHeader/HomeHeaderBar';
import { serviceBundler, webSocketService } from '../../App';
import { NotificationModule } from '../../Models/Notifications/NotificationMachine';
import { MyList } from '../../Components/CustomAnimatedList/CustomAnimatedList';

const { Content } = Layout;
const { useToken } = theme;

import { Tour } from 'antd';
import { ShowTour } from '../../Components/Devices/Forms/Tour/ShowTour';
import { LocalHelper } from '../../Helpers/LocalHelper';
import { TourHelper } from '../../Helpers/TourHelper';

import type { NotificationArgsProps } from 'antd';
type NotificationType = 'success' | 'info' | 'warning' | 'error';
type NotificationPlacement = NotificationArgsProps['placement'];

const Context = React.createContext({ name: 'Default' });

const Home = () => {
  const { t, i18n } = useTranslation();
  const { token } = useToken();

  const notificationRef = useRef<any>(null);

  const [currentTourStep, setCurrentTourStep] = useState<number>(0);

  const refStep1 = useRef<any>(null);
  const refStep2 = useRef<any>(null);
  const refStep3 = useRef<any>(null);
  const refStep4 = useRef<any>(null);

  const [tourModelOpen, setTourModelOpen] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const steps: TourProps['steps'] = [
    TourHelper.CreateTourSteps(
      t,
      'Notificaties',
      'Hier worden alle actieve notificaties getoond',
      'top',
      refStep1.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Instellingen webportaal',
      'Hier kun je de instellingen van het systeem vinden',
      'left',
      refStep2.current,
    ),
  ];

  useEffect(() => {
    serviceBundler.notificationService.notificationsChannel.subscribe(
      (value) => {
        if (Array.isArray(value)) {
          AddItems(value);
        }
      },
    );

    serviceBundler.notificationService.notificationsToKillChannel.subscribe(
      (value) => {
        if (Array.isArray(value)) {
          RemoveItems(value);
        }
      },
    );

    if (serviceBundler.notificationService.notificationsProcessed.length >= 1) {
      AddItems(serviceBundler.notificationService.notificationsProcessed);
    }

    serviceBundler.tourService.TourHomePageSubject.subscribe((value) => {
      if (value) {
        if (serviceBundler.tourService.tourHomePageActive) {
          setTourModelOpen(false);
          setCurrentTourStep(1);
        } else {
          setCurrentTourStep(0);
        }
      }
    });

    var result = LocalHelper.GetValueByKey('firstUser');
    if (result == null) {
      setTourModelOpen(true);
      LocalHelper.SafeValueWithKey('firstUser', 'true');
    }
  }, [0]);

  useEffect(() => {
    var intervalId = window.setInterval(async () => {
      var isOnline = await serviceBundler.coreService.CheckServiceIsOnline();
      if (!isOnline) {
        setIsModalOpen(true);
        if (!serviceBundler.coreService.IsNotificationShown())
          openNotificationWithIcon('error', t('serviceOffline'), t('serviceOfflineDesc'));
        serviceBundler.coreService.ShowNotification(true);
      } else {
        setIsModalOpen(false);
        serviceBundler.coreService.ShowNotification(false);
        api.destroy('notificationKey');
      }
    }, 1000);
  }, [0]);

  const AddItems = (items: NotificationModule[]) => {
    const node = notificationRef.current;
    if (node) {
      node.AddNotifications(items);
    }
  };

  const RemoveItems = (items: NotificationModule[]) => {
    const node = notificationRef.current;
    if (node) {
      node.RemoveNotifications(items);
    }
  };

  const RemoveAllNotifications = () => {
    const node = notificationRef.current;
    if (node) {
      node.RemoveAllNotifications(
        serviceBundler.notificationService.notificationsProcessed,
      );
    }

    serviceBundler.notificationService.notificationsProcessed = [];
  };

  const StartSpecicifcTour = (step: number) => {
    if (currentTourStep == step) {
      return true;
    }
    return false;
  };

  const OpenTourModal = () => {
    setTourModelOpen(true);
  };

  const StartTour = () => {
    setTourModelOpen(false);
    setCurrentTourStep(1);
  };

  const TourHomeBarReady = () => {
    setCurrentTourStep(2);
  };

  const TourHomeReady = () => {
    setCurrentTourStep(0);
    serviceBundler.tourService.EndHomePageTour();
  };

  const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
    api[type]({
      key: 'notificationKey',
      message: message,
      description: description,
      duration: 0,
      placement: 'bottomLeft' as NotificationPlacement,
    });
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
      <Layout>
        <ShowTour
          open={tourModelOpen}
          onCancel={() => setTourModelOpen(false)}
        ></ShowTour>
        <Tour
          open={StartSpecicifcTour(2)}
          onClose={() => TourHomeReady()}
          steps={steps}
        />

        <Header className={style.headerStyle}>
          <HomeHeaderBar
            startTour={StartSpecicifcTour(1)}
            SetTourFinished={() => TourHomeBarReady()}
          ></HomeHeaderBar>
        </Header>
        <Content
          style={{ backgroundColor: token.colorPrimaryBg }}
          className={style.contentBlock}
        >
          <div ref={refStep1}>
            <MyList ref={notificationRef}></MyList>
          </div>
          <Button
            type="primary"
            onClick={() => OpenTourModal()}
            className={style.btnStartTour}
          >
            {t('startTour')}
          </Button>
          <Button
            onClick={RemoveAllNotifications}
            type="primary"
            size="large"
            className={style.btnRemoveMsg}
            ref={refStep2}
          >
            {t('removeAllMessages')}
          </Button>
          {/* <Modal
            title="Storing"
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isModalOpen}
            onOk={() => ApproveMessage()}
            onCancel={() => ApproveMessage()}
            className={style.modelMalfunction}
          >
            De service is niet ingeschakeld of er is een verbindingsprobleem.
          </Modal> */}
          {contextHolder}
        </Content>
      </Layout>
    </Space>
  );
};

export default Home;
